import { Component, computed, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { SliderComponent } from '../slider/slider.component';
import {PositionDirective} from "../../../../directives/position.directive";
import {ComponentEntity} from "../../../../entities/component-entity";
import {carouselComponent} from "../../../../commons/defaults-components";

interface Image {
  src: string;
  title?: string;
  alt?: string;
}

@Component({
  selector: 'lib-carousel',
  standalone: true,
    imports: [
        CommonModule,
        NgOptimizedImage,
        SliderComponent,
        PositionDirective,
    ],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.css',
  animations: [
    trigger('activeSlide', [
      state(
        'active',
        style({
          transform: 'scale(1.4)',
          opacity: 1,
        })
      ),
      state(
        'inActive',
        style({
          transform: 'scale(0.7)',
          opacity: 0.8,
        })
      ),
      transition('active => inActive', [animate('0.5s')]),
      transition('inActive => active', [animate('0.5s')]),
    ]),
  ],
})
export class CarouselComponent {
  component = input<ComponentEntity>(carouselComponent());
}
